import { Component } from '@angular/core';

@Component({
  selector: 'ui-content',
  templateUrl: './content.component.html'
})
export class ContentComponent {
}
